// /src/store/modules/media.js
import { apiGet, futureDate } from '@/services/API'
import { mStore } from '@/services/Storage'
import CommonGetters from '@/store/common/getters'

export const namespaced = true

let taxPolling = null

export const state = {
  nextAPIRun: 0,
  images: {
    data: [],
  },
  audios: {
    data: [],
  },
  downloads: {
    data: [],
  },
}

export const mutations = {
  SET_API_NEXT_RUN(state, date) {
    state.nextAPIRun = date
  },
  SET_IMAGES(state, images) {
    state.images = images
  },
  SET_AUDIOS(state, audios) {
    state.audios = audios
  },
  SET_DOWNLOADS(state, downloads) {
    state.downloads = downloads
  },
}

export const actions = {
  getAll({ commit, state, dispatch }) {
    try {
      const currentDateTime = new Date().getTime()
      console.log(state.nextAPIRun)
      if (state.nextAPIRun < currentDateTime) {
        dispatch('requestMedia')
      }
      // dispatch('polling', true)
    } catch (err) {
      dispatch(
        'notification/add',
        {
          type: 'error',
          msg: err,
          closable: true,
          autoClose: false,
        },
        { root: true },
      )
    }
  },
  async requestMedia({ commit, state, dispatch }) {
    const apiRequests = mStore.apiRequests
    try {
      await Promise.all(
        Object.keys(apiRequests).map(async key => {
          const config = apiRequests[key]
          const { data } = await apiGet(config.apiPath, config.defaultArgs)
          const mediaItem = {
            title: config.title,
            routePath: config.routePath,
            titlePlural: config.titlePlural,
            data,
          }
          console.log({commit: config.stateCommit, mediaItem})
          commit(config.stateCommit, mediaItem)
        }),
      )
      dispatch('updateAPIRunTimes')
    } catch (err) {
      dispatch('polling', false)
      dispatch(
        'notification/add',
        {
          type: 'error',
          msg: 'Request Taxonomies Failed: ' + err,
          closable: true,
          autoClose: false,
        },
        { root: true },
      )
    }
  },
  polling({ commit, dispatch }, bool = true) {
    if (!bool) {
      clearInterval(taxPolling)
      taxPolling = null
      return
    }
    if (taxPolling === null) {
      taxPolling = setInterval(function() {
        dispatch('getAll')
      }, 600000)
    }
  },
  updateAPIRunTimes({ commit }, date) {
    commit('SET_API_NEXT_RUN', futureDate(new Date().getTime())) // default date time set by API
  },
}

export const getters = {
  ...CommonGetters,
}
